export const APP_LOCALES = ['ru', 'en-US'];
export const DEFAULT_LOCALE = 'ru';
